import React, { useEffect } from 'react';
import { useSession } from '../util/SessionContext';
import { SESSION_KILLED_EVENT } from '../util/ApiHelper';
import SessionKilledModal from './SessionKilledModal';

const SessionKilledListener: React.FC = () => {
  const { isSessionKilled, killedBy, setSessionKilled, handleSessionRelogin } = useSession();

  useEffect(() => {
    const handleSessionKilled = (event: CustomEvent) => {
      const killedBy = event.detail?.killedBy || 'Administrator';
      setSessionKilled(true, killedBy);
    };

    document.addEventListener(
      SESSION_KILLED_EVENT, 
      handleSessionKilled as EventListener
    );

    return () => {
      document.removeEventListener(
        SESSION_KILLED_EVENT, 
        handleSessionKilled as EventListener
      );
    };
  }, [setSessionKilled]);

  return (
    <SessionKilledModal 
      isOpen={isSessionKilled}
      killedBy={killedBy}
      onLogin={handleSessionRelogin}
    />
  );
};

export default SessionKilledListener; 